/* eslint-disable no-prototype-builtins */
/* eslint-disable no-plusplus */
/* eslint-disable no-mixed-operators */
/* eslint-disable max-len */

import React, { useEffect, useState, useRef } from "react";
import { PropTypes } from "prop-types";
import moment from "moment";
// import JsPDF from 'jspdf';
import { useDispatch, useSelector } from "react-redux";

import {
  Select,
  Row,
  Col,
  DatePicker,
  Modal,
  Button,
  Popover,
  Input,
  Divider,
  Popconfirm,
  Radio,
} from "antd";
import { MailOutlined, SaveOutlined } from "@ant-design/icons";
import ButtonGroup from "antd/lib/button/button-group";
import Merchants from "./index";
import logo from "../../assets/images/kitegateway_icon_dark.png";
import { apiBaseUrl, dateAndTimeRangeQueriesArray } from "../../util/lib";

import {
  createSettlementReport,
  fetchWalletOverviewPerPSP,
  updateSettlementReport,
  fetchSettlementReports,
} from "../../redux/actions/Data";
import { fetchTransactionSummary } from "../../redux/actions/Transactions";
import { TransactionStatuses, TransactionTypes } from "../../constants/System";
import Can from "../../util/can";
import { SETTLEMENT_REPORTS } from "../../constants/resources";

const { Option } = Select;
const { RangePicker } = DatePicker;
const calculateInitialState = (editable, selectedMerchant) => ({
  selectedPaymentMethod: editable?.payment_method || "CARD",
  selectedStatus: editable?.status || "PENDING",
  selectedStatusParent1: editable?.status_parent1 || "PENDING",
  selectedStatusParent2: editable?.status_parent2 || "PENDING",
  selectedRRStatus: editable?.rrstatus || "PENDING",
  statementDate: editable?.statement_date,
  settlementDate: editable?.settlement_date,
  begin_date: editable?.begin_date,
  end_date: editable?.end_date,
  percFee: editable?.perc_charge || 0,
  percFeeParent1: editable?.perc_charge_parent1 || 0,
  percFeeParent2: editable?.perc_charge_parent2 || 0,
  fixedFee: editable?.fixed_charge || 0,
  fixedFeeParent1: editable?.fixed_charge_parent1 || 0,
  fixedFeeParent2: editable?.fixed_charge_parent2 || 0,
  failureFee: editable?.failure_fee || 0,
  failureFeeParent1: editable?.failure_fee_parent1 || 0,
  failureFeeParent2: editable?.failure_fee_parent2 || 0,
  rollingReserve: editable?.rolling_reserve || 0,
  chargebackFee: editable?.chargeback_fee || 0,
  chargebackFeeParent1: editable?.chargeback_fee_parent1 || 0,
  chargebackFeeParent2: editable?.chargeback_fee_parent2 || 0,
  refundFee: editable?.refund_fee || 0,
  refundFeeParent1: editable?.refund_fee_parent1 || 0,
  refundFeeParent2: editable?.refund_fee_parent2 || 0,
  conversionRate: editable?.usd_rate || 0,
  conversionRateParent1: editable?.usd_rate_parent1 || 0,
  conversionRateParent2: editable?.usd_rate_parent2 || 0,
  conversionRateBank: editable?.usd_rate_bank || 0,
  usdtRate: editable?.usdt_fee || 0,
  usdtRateParent1: editable?.usdt_fee_parent1 || 0,
  usdtRateParent2: editable?.usdt_fee_parent2 || 0,
  usdtRateBank: editable?.usdt_fee_bank || 0,
  settlementFee: editable?.settlement_fee || 0,
  settlementFeeParent1: editable?.settlement_fee_parent1 || 0,
  settlementFeeParent2: editable?.settlement_fee_parent2 || 0,
  otherDeductions: editable?.other_deduction_amount || 0,
  otherDeductionsParent1: editable?.other_deduction_amount_parent1 || 0,
  otherDeductionsParent2: editable?.other_deduction_amount_parent2 || 0,
  otherAdditions: editable?.other_additional_amount || 0,
  otherAdditionsParent1: editable?.other_additional_amount_parent1 || 0,
  otherAdditionsParent2: editable?.other_additional_amount_parent2 || 0,
  usdtAddress: editable?.usdt_address || "",
  usdtAddressParent1: editable?.usdt_address_parent1 || "",
  usdtAddressParent2: editable?.usdt_address_parent2 || "",
  usdtHash: editable?.usdt_hash || "",
  usdtHashParent1: editable?.usdt_hash_parent1 || "",
  usdtHashParent2: editable?.usdt_hash_parent2 || "",
  notes: editable?.notes || "",
  notesParent1: editable?.notes_parent1 || "",
  notesParent2: editable?.notes_parent2 || "",
  merchantEmails: editable?.merchant_emails || [selectedMerchant?.email],
  merchantEmailsParent1: editable?.merchant_emails_parent1 || [],
  merchantEmailsParent2: editable?.merchant_emails_parent2 || [],
  nextStatementCreated: editable?.next_statement_created || false,
  merchantId: editable?.merchant_id || selectedMerchant?._id,
  merchantIdParent1: editable?.merchant_id_parent1 || null,
  merchantIdParent2: editable?.merchant_id_parent2 || null,
  merchantName: editable?.business_name || selectedMerchant?.name || null,
  merchantNameParent1: editable?.business_name_parent1 || null,
  merchantNameParent2: editable?.business_name_parent2 || null,
  card_settlement_period: editable?.card_settlement_period || selectedMerchant?.card_settlement_period || 7,
});

const SettlementReport = ({
  wallet,
  isAffiliate,
  editable,
  selectedMerchant,
  puppeteerPDF,
  puppeteerParent1PDF,
  puppeteerParent2PDF,
}) => {
  const dispatch = useDispatch();
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const { timezone } = useSelector(({ settings }) => settings);
  const { authUser } = useSelector(({ auth }) => auth);
  const unicornApi = apiBaseUrl(process.env.REACT_APP_UNICORN_API);

  const {
    data: settlementReports,
    currentPage: settlementReportsCurrentPage,
    creatingSettlementReport,
    autoSaveExecuted,
    updatingSettlementReport,
  } = useSelector(({ data }) => data.settlementReports);

  let {
    COLLECTION: wOCollection,
    REFUND: wORefund,
    CHARGEBACK: wOChargeback,
    loading: loadingWO,
  } = useSelector(({ data }) => data.walletOverviewPerPSP);

  let { COLLECTIONFAILED: tsCollectionFailed, loading: loadingTS } =
    useSelector(({ transactions }) => transactions.transactionSummaryFailed);

  useEffect(() => {
    const filter = JSON.stringify({
      wallet_currency_code: wallet.code,
      merchant_id: selectedMerchant?._id || editable?.merchant_id,
    });
    const pagination = `filter=${filter}&page=${settlementReportsCurrentPage}&limit=${1}&sort={"statement_date": -1 }`;
    dispatch(fetchSettlementReports(pagination));
  }, [dispatch, selectedMerchant, editable, wallet?.code, settlementReportsCurrentPage]);

  const initialState = calculateInitialState(editable, selectedMerchant);

  const [prevReport, setPrevReport] = useState(null);
  const [visibleSelectChildMerchantModal, setVisibleSelectChildMerchantModal] =
    useState(false);
  const [selectedChildMerchant, setSelectedChildMerchant] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(
    initialState.selectedPaymentMethod
  );
  const [selectedStatus, setSelectedStatus] = useState(
    initialState.selectedStatus
  );
  const [selectedStatusParent1, setSelectedStatusParent1] = useState(
    initialState.selectedStatusParent1
  );
  const [selectedStatusParent2, setSelectedStatusParent2] = useState(
    initialState.selectedStatusParent2
  );
  const [selectedRRStatus, setSelectedRRStatus] = useState(
    initialState.selectedRRStatus
  );
  const [statementDate, setStatementDate] = useState(
    moment(initialState.statementDate).format("YYYY-MM-DD")
  );
  const [settlementDate, setSettlementDate] = useState(
    moment(initialState.settlementDate).format("YYYY-MM-DD")
  );
  const [dateRange, setSelectedDateRangeString] = useState([
    moment(initialState.begin_date).format("YYYY-MM-DD"),
    moment(initialState.end_date).format("YYYY-MM-DD"),
  ]);
  const [dateRangeValue, setSelectedDateRangeValue] = useState([
    moment(initialState.begin_date),
    moment(initialState.end_date),
  ]);
  const [percFee, setPercentageFee] = useState(initialState.percFee);
  const [percFeeParent1, setPercentageFeeParent1] = useState(
    initialState.percFeeParent1
  );
  const [percFeeParent2, setPercentageFeeParent2] = useState(
    initialState.percFeeParent2
  );
  const [fixedFee, setFixedFee] = useState(initialState.fixedFee);
  const [fixedFeeParent1, setFixedFeeParent1] = useState(
    initialState.fixedFeeParent1
  );
  const [fixedFeeParent2, setFixedFeeParent2] = useState(
    initialState.fixedFeeParent2
  );
  const [failureFee, setFailureFee] = useState(initialState.failureFee);
  const [failureFeeParent1, setFailureFeeParent1] = useState(
    initialState.failureFeeParent1
  );
  const [failureFeeParent2, setFailureFeeParent2] = useState(
    initialState.failureFeeParent2
  );
  const [rollingReserve, setRollingReserve] = useState(
    initialState.rollingReserve
  );
  const [chargebackFee, setChargebackFee] = useState(
    initialState.chargebackFee
  );
  const [chargebackFeeParent1, setChargebackFeeParent1] = useState(
    initialState.chargebackFeeParent1
  );
  const [chargebackFeeParent2, setChargebackFeeParent2] = useState(
    initialState.chargebackFeeParent2
  );
  const [refundFee, setRefundFee] = useState(initialState.refundFee);
  const [refundFeeParent1, setRefundFeeParent1] = useState(
    initialState.refundFeeParent1
  );
  const [refundFeeParent2, setRefundFeeParent2] = useState(
    initialState.refundFeeParent2
  );
  const [conversionRate, setConversionRate] = useState(
    initialState.conversionRate
  );
  const [conversionRateParent1, setConversionRateParent1] = useState(
    initialState.conversionRateParent1
  );
  const [conversionRateParent2, setConversionRateParent2] = useState(
    initialState.conversionRateParent2
  );
  const [conversionRateBank, setConversionRateBank] = useState(
    initialState.conversionRateBank
  );
  const [usdtRate, setUsdtRate] = useState(initialState.usdtRate);
  const [usdtRateParent1, setUsdtRateParent1] = useState(
    initialState.usdtRateParent1
  );
  const [usdtRateParent2, setUsdtRateParent2] = useState(
    initialState.usdtRateParent2
  );
  const [usdtRateBank, setUsdtRateBank] = useState(initialState.usdtRateBank);
  const [otherDeductions, setOtherDeductions] = useState(
    initialState.otherDeductions
  );
  const [otherDeductionsParent1, setOtherDeductionsParent1] = useState(
    initialState.otherDeductionsParent1
  );
  const [otherDeductionsParent2, setOtherDeductionsParent2] = useState(
    initialState.otherDeductionsParent2
  );
  const [settlementFee, setSettlementFee] = useState(
    initialState.settlementFee
  );
  const [settlementFeeParent1, setSettlementFeeParent1] = useState(
    initialState.settlementFeeParent1
  );
  const [settlementFeeParent2, setSettlementFeeParent2] = useState(
    initialState.settlementFeeParent2
  );
  const [otherAdditions, setOtherAdditions] = useState(
    initialState.otherAdditions
  );
  const [otherAdditionsParent1, setOtherAdditionsParent1] = useState(
    initialState.otherAdditionsParent1
  );
  const [otherAdditionsParent2, setOtherAdditionsParent2] = useState(
    initialState.otherAdditionsParent2
  );
  const [usdtAddress, setUsdtAddress] = useState(initialState.usdtAddress);
  const [usdtAddressParent1, setUsdtAddressParent1] = useState(
    initialState.usdtAddressParent1
  );
  const [usdtAddressParent2, setUsdtAddressParent2] = useState(
    initialState.usdtAddressParent2
  );
  const [usdtHash, setUsdtHash] = useState(initialState.usdtHash);
  const [usdtHashParent1, setUsdtHashParent1] = useState(
    initialState.usdtHashParent1
  );
  const [usdtHashParent2, setUsdtHashParent2] = useState(
    initialState.usdtHashParent2
  );
  const [notes, setNotes] = useState(initialState.notes);
  const [notesParent1, setNotesParent1] = useState(initialState.notesParent1);
  const [notesParent2, setNotesParent2] = useState(initialState.notesParent2);
  const [loadReportClicked, setLoadReportClicked] = useState(false);
  const [datesUpdated, setDatesUpdated] = useState(false);
  const [merchantEmails, setMerchantEmails] = useState(
    initialState.merchantEmails
  );
  const [merchantEmailsParent1, setMerchantEmailsParent1] = useState(
    initialState.merchantEmailsParent1
  );
  const [merchantEmailsParent2, setMerchantEmailsParent2] = useState(
    initialState.merchantEmailsParent2
  );
  const [nextStatementCreated, setNextStatementCreated] = useState(
    initialState.nextStatementCreated
  );
  const [merchantId, setMerchantId] = useState(initialState.merchantId);
  const [merchantIdParent1, setMerchantIdParent1] = useState(
    initialState.merchantIdParent1
  );
  const [merchantIdParent2, setMerchantIdParent2] = useState(
    initialState.merchantIdParent2
  );
  const [merchantName, setMerchantName] = useState(initialState.merchantName);
  const [merchantNameParent1, setMerchantNameParent1] = useState(
    initialState.merchantNameParent1
  );
  const [merchantNameParent2, setMerchantNameParent2] = useState(
    initialState.merchantNameParent2
  );

  if (editable) {
    loadingWO = false;
    loadingTS = false;

    wOCollection = {
      total_transaction_amount: editable.successful_amount,
      total_transactions: editable.successful_count,
      ...wOCollection,
      ...editable?.collection_overview,
    };

    wORefund = {
      total_transaction_amount: editable.refunds_amount,
      total_transactions: editable.refunds_count,
      ...wORefund,
      ...editable?.refund_overview,
    };

    wOChargeback = {
      total_transaction_amount: editable.chargebacks_amount,
      total_transactions: editable.chargebacks_count,
      ...wOChargeback,
      ...editable?.chargeback_overview,
    };

    tsCollectionFailed = {
      total_transaction_amount: editable.failed_amount,
      total_count: editable.failed_count,
    };
  }

  const fetchOverviewPerPSP = (transactionType) => {
    if ((selectedMerchant || editable) && wallet?.code && dateRange?.length === 2) {
      const queries = [
        `merchant_id=${selectedMerchant?._id || editable?.merchant_id}`,
        `is_affiliate=${
          selectedMerchant?.enable_affiliate || editable?.is_affiliate
        }`,
        `transaction_currency=${
          wallet?.code || editable?.transaction_currency
        }`,
        `transaction_type=${transactionType}`,
        ...dateAndTimeRangeQueriesArray(dateRange[0], dateRange[1], timezone),
      ];

      if (selectedChildMerchant) {
        queries.push(`child_merchant=${selectedChildMerchant._id}`);
      }
      const params = queries.join("&");
      dispatch(fetchWalletOverviewPerPSP(params, transactionType));
    }
  };

  const fetchSummary = (transactionType, transactionStatus) => {
    if (selectedMerchant && wallet?.code && dateRange?.length === 2) {
      const queries = [
        `merchant_id={"$in": ["${selectedMerchant?._id}"]}`,
        `is_affiliate=${selectedMerchant?.enable_affiliate}`,
        `transaction_currency=${wallet.code}`,
        `transaction_type=${transactionType}`,
        `transaction_status=${transactionStatus}`,
        ...dateAndTimeRangeQueriesArray(dateRange[0], dateRange[1], timezone),
      ];
      if (selectedChildMerchant) {
        queries.push(`child_merchant=${selectedChildMerchant._id}`);
      }
      const params = queries.join("&");
      dispatch(
        fetchTransactionSummary(params, transactionType, transactionStatus)
      );
    }
  };

  const loadReport = () => {
    fetchOverviewPerPSP(TransactionTypes.COLLECTION);
    fetchOverviewPerPSP(TransactionTypes.REFUND);
    fetchOverviewPerPSP(TransactionTypes.CHARGEBACK);

    if (!editable) {
      fetchSummary(TransactionTypes.COLLECTION, TransactionStatuses.FAILED);
    }
    setLoadReportClicked(true);
  };

  if (
    !editable?.collection_overview?.perPSP &&
    !editable?.refund_overview?.perPSP &&
    !editable?.chargeback_overview?.perPSP
  ) {
    if (!loadReportClicked) loadReport();
  }

  if (!editable && settlementReports?.length > 0 && !prevReport && mountedRef.current) {
    const pReport = settlementReports[0];
    if (pReport.wallet_currency_code === wallet?.code) {
      setPrevReport(pReport);
      setPercentageFee(pReport?.perc_charge);
      setFixedFee(pReport?.fixed_charge);
      setFailureFee(pReport?.failure_fee);
      setRollingReserve(pReport?.rolling_reserve);
      setChargebackFee(pReport?.chargeback_fee);
      setRefundFee(pReport?.refund_fee);
      setConversionRate(pReport?.usd_rate);
      setConversionRateBank(pReport?.usd_rate_bank);
      setUsdtRate(pReport?.usdt_fee);
      setUsdtRateBank(pReport?.usdt_fee_bank);
      setSelectedDateRangeString([
        moment(pReport?.end_date).add(1, "day").format("YYYY-MM-DD"),
        moment(pReport?.end_date).add(editable?.card_settlement_period || selectedMerchant?.card_settlement_period, "day").format("YYYY-MM-DD"),
      ]);
      setSelectedDateRangeValue([
        moment(pReport?.end_date).add(1, "day"),
        moment(pReport?.end_date).add(editable?.card_settlement_period || selectedMerchant?.card_settlement_period, "day"),
      ]);
      setStatementDate(moment(pReport?.statement_date));
      setSettlementDate(moment(pReport?.settlement_date));
      setDatesUpdated(true);
      setUsdtAddress(pReport?.usdt_address);
      setMerchantEmails(pReport?.merchant_emails);
      setMerchantEmailsParent1(pReport?.merchant_emails_parent1);
      setMerchantEmailsParent2(pReport?.merchant_emails_parent2);
      setMerchantId(pReport?.merchant_id);
      setMerchantIdParent1(pReport?.merchant_id_parent1);
      setMerchantIdParent2(pReport?.merchant_id_parent2);
      setMerchantName(pReport?.business_name);
      setMerchantNameParent1(pReport?.business_name_parent1);
      setMerchantNameParent2(pReport?.business_name_parent2);
      setPercentageFeeParent1(pReport?.perc_charge_parent1);
      setPercentageFeeParent2(pReport?.perc_charge_parent2);
      setFixedFeeParent1(pReport?.fixed_charge_parent1);
      setFixedFeeParent2(pReport?.fixed_charge_parent2);
      setFailureFeeParent1(pReport?.failure_fee_parent1);
      setFailureFeeParent2(pReport?.failure_fee_parent2);
      setChargebackFeeParent1(pReport?.chargeback_fee_parent1);
      setChargebackFeeParent2(pReport?.chargeback_fee_parent2);
      setRefundFeeParent1(pReport?.refund_fee_parent1);
      setRefundFeeParent2(pReport?.refund_fee_parent2);
      setConversionRateParent1(pReport?.usd_rate_parent1);
      setConversionRateParent2(pReport?.usd_rate_parent2);
      setUsdtRateParent1(pReport?.usdt_fee_parent1);
      setUsdtRateParent2(pReport?.usdt_fee_parent2);
      setSettlementFee(pReport?.settlement_fee);
      setSettlementFeeParent1(pReport?.settlement_fee_parent1);
      setSettlementFeeParent2(pReport?.settlement_fee_parent2);
    }
  }

  const selectChildMerchant = () => {
    setVisibleSelectChildMerchantModal(true);
  };

  const closeSelectChildMerchantModal = () => {
    setVisibleSelectChildMerchantModal(false);
  };

  const OkSelectChildMerchantModal = (childMerchant) => {
    if (childMerchant) {
      setSelectedChildMerchant(childMerchant);
    }
    setVisibleSelectChildMerchantModal(false);
  };

  const onDateRangeChanged = (value, dateString) => {
    setSelectedDateRangeValue(value);
    setSelectedDateRangeString(dateString);
  };

  const onPaymentMethodChanged = (e) => setSelectedPaymentMethod(e);
  const onStatusChanged = (e) => setSelectedStatus(e);
  const onStatusChangedParent1 = (e) => setSelectedStatusParent1(e);
  const onStatusChangedParent2 = (e) => setSelectedStatusParent2(e);
  const onRRStatusChanged = (e) => setSelectedRRStatus(e);

  const paymentMethodOptions = ["MOBILE_MONEY", "CARD"].map((e) => (
    <Option key={e} value={e}>
      {e}
    </Option>
  ));

  const settlementStatuses = ["PENDING", "PROCESSING", "COMPLETED"].map((e) => (
    <Option key={e} value={e}>
      {e}
    </Option>
  ));

  const colSize = isAffiliate ? 6 : 8;

  const onChangeStatementDate = (e) => {
    setStatementDate(e.format("YYYY-MM-DD"));
  };
  const onChangeSettlementDate = (e) => {
    setSettlementDate(e.format("YYYY-MM-DD"));
  };

  const onChangePercentageFee = (e) => setPercentageFee(e.target.value);
  const onChangePercentageFeeParent1 = (e) =>
    setPercentageFeeParent1(e.target.value);
  const onChangePercentageFeeParent2 = (e) =>
    setPercentageFeeParent2(e.target.value);
  const onChangeFixedFee = (e) => setFixedFee(e.target.value);
  const onChangeFixedFeeParent1 = (e) => setFixedFeeParent1(e.target.value);
  const onChangeFixedFeeParent2 = (e) => setFixedFeeParent2(e.target.value);
  const onChangeFailureFee = (e) => setFailureFee(e.target.value);
  const onChangeFailureFeeParent1 = (e) => setFailureFeeParent1(e.target.value);
  const onChangeFailureFeeParent2 = (e) => setFailureFeeParent2(e.target.value);
  const onChangeRollingReserve = (e) => setRollingReserve(e.target.value);
  const onChangeChargebackFee = (e) => setChargebackFee(e.target.value);
  const onChangeChargebackFeeParent1 = (e) =>
    setChargebackFeeParent1(e.target.value);
  const onChangeChargebackFeeParent2 = (e) =>
    setChargebackFeeParent2(e.target.value);
  const onChangeRefundFee = (e) => setRefundFee(e.target.value);
  const onChangeRefundFeeParent1 = (e) => setRefundFeeParent1(e.target.value);
  const onChangeRefundFeeParent2 = (e) => setRefundFeeParent2(e.target.value);
  const onChangeConversionRate = (e) => setConversionRate(e.target.value);
  const onChangeConversionRateParent1 = (e) =>
    setConversionRateParent1(e.target.value);
  const onChangeConversionRateParent2 = (e) =>
    setConversionRateParent2(e.target.value);
  const onChangeConversionRateBank = (e) =>
    setConversionRateBank(e.target.value);
  const onChangeUsdtRate = (e) => setUsdtRate(e.target.value);
  const onChangeUsdtRateParent1 = (e) => setUsdtRateParent1(e.target.value);
  const onChangeUsdtRateParent2 = (e) => setUsdtRateParent2(e.target.value);
  const onChangeUsdtRateBank = (e) => setUsdtRateBank(e.target.value);
  const onChangeSettlementFee = (e) => setSettlementFee(e.target.value);
  const onChangeSettlementFeeParent1 = (e) =>
    setSettlementFeeParent1(e.target.value);
  const onChangeSettlementFeeParent2 = (e) =>
    setSettlementFeeParent2(e.target.value);
  const onChangeOtherDeductions = (e) => setOtherDeductions(e.target.value);
  const onChangeOtherDeductionsParent1 = (e) =>
    setOtherDeductionsParent1(e.target.value);
  const onChangeOtherDeductionsParent2 = (e) =>
    setOtherDeductionsParent2(e.target.value);
  const onChangeOtherAdditions = (e) => setOtherAdditions(e.target.value);
  const onChangeOtherAdditionsParent1 = (e) =>
    setOtherAdditionsParent1(e.target.value);
  const onChangeOtherAdditionsParent2 = (e) =>
    setOtherAdditionsParent2(e.target.value);
  const onChangeUsdtAddress = (e) => setUsdtAddress(e.target.value);
  const onChangeUsdtAddressParent1 = (e) =>
    setUsdtAddressParent1(e.target.value);
  const onChangeUsdtAddressParent2 = (e) =>
    setUsdtAddressParent2(e.target.value);
  const onChangeUsdtHash = (e) => setUsdtHash(e.target.value);
  const onChangeUsdtHashParent1 = (e) => setUsdtHashParent1(e.target.value);
  const onChangeUsdtHashParent2 = (e) => setUsdtHashParent2(e.target.value);
  const onChangeNotes = (e) => setNotes(e.target.value);
  const onChangeNotesParent1 = (e) => setNotesParent1(e.target.value);
  const onChangeNotesParent2 = (e) => setNotesParent2(e.target.value);

  const handleInputEmails = (e) => {
    let em = [];
    e.forEach((ele) => {
      if (ele?.trim()?.length > 3) {
        em = [...em, ...ele.split(",")];
      }
    });

    let em1 = [];
    em.forEach((elt) => {
      if (elt?.trim()?.length > 3) {
        em1 = [...em1, elt?.trim()];
      }
    });

    return em1;
  };

  const onChangeMerchantEmails = (e) => setMerchantEmails(handleInputEmails(e));
  const onChangeMerchantEmailsParent1 = (e) =>
    setMerchantEmailsParent1(handleInputEmails(e));
  const onChangeMerchantEmailsParent2 = (e) =>
    setMerchantEmailsParent2(handleInputEmails(e));
  const onChangeNextStatementCreated = (e) =>
    setNextStatementCreated(e.target.value);

  // const download = async (id) => {
  //   const report = new JsPDF('portrait', 'pt', 'a4');
  //   const data = document.querySelector(`#${id}`);
  //   report.html(data, {
  //     margin: [10, 10, 10, 10],
  //     x: 0,
  //     y: 0,
  //     width: 580,
  //     windowWidth: 1000,
  //   }).then(() => {
  //     const dfrom = moment(dateRange[0]).format('DD-MMM-YY');
  //     const dto = moment(dateRange[1]).format('DD-MMM-YY');
  //     let fileName = `${id}`;
  //     fileName += `-${editable?.wallet_currency_code || wallet.currency.code}`;
  //     fileName += `-${dfrom}-to-${dto}`;
  //     fileName += `-${editable?.business_name || selectedMerchant?.name}`;
  //     report.save(`${fileName}.pdf`);
  //   }).catch(console.error);
  // };

  const getNetSuccessAmount = () => {
    const collected = wOCollection?.total_transaction_amount || 0;
    const refunded = wORefund?.total_transaction_amount || 0;
    const chargedBack = wOChargeback?.total_transaction_amount || 0;

    return collected - refunded - chargedBack;
  };

  const getRollingReserveAmount = () => {
    // if (getNetSuccessAmount() <= 0) return 0;

    // return (getNetSuccessAmount() * rollingReserve) / 100;
    const collected = wOCollection?.total_transaction_amount || 0;
    return (collected * rollingReserve) / 100;
  };

  const totalDeductionAmount = () => {
    const atPercCharge =
      ((wOCollection?.total_transaction_amount || 0) * percFee) / 100;
    const atFixedFee = (wOCollection?.total_transactions || 0) * fixedFee;
    const failureFeeAmout = (tsCollectionFailed?.total_count || 0) * failureFee;
    const rollingReserveAmount = getRollingReserveAmount();
    const chargebackFees =
      (wOChargeback?.total_transactions || 0) * chargebackFee;
    const refundFees = (wORefund?.total_transactions || 0) * refundFee;

    const p1 = atPercCharge + atFixedFee + failureFeeAmout;
    const p2 = rollingReserveAmount + chargebackFees + refundFees;
    return Number(p1 + p2) + Number(otherDeductions) + Number(settlementFee);
  };

  const totalDeductionAmountParent1 = () => {
    if (!merchantIdParent1) return 0;

    const atPercCharge =
      ((wOCollection?.total_transaction_amount || 0) *
        (percFee - percFeeParent1)) /
      100;
    const atFixedFee =
      (wOCollection?.total_transactions || 0) * (fixedFee - fixedFeeParent1);
    const failureFeeAmout =
      (tsCollectionFailed?.total_count || 0) * (failureFee - failureFeeParent1);
    const chargebackFees =
      (wOChargeback?.total_transactions || 0) *
      (chargebackFee - chargebackFeeParent1);
    const refundFees =
      (wORefund?.total_transactions || 0) * (refundFee - refundFeeParent1);

    const p1 = atPercCharge + atFixedFee + failureFeeAmout;
    const p2 = chargebackFees + refundFees;
    return (
      Number(p1 + p2) -
      (Number(otherDeductionsParent1) + Number(settlementFeeParent1))
    );
  };

  const totalDeductionAmountParent2 = () => {
    if (!merchantIdParent2) return 0;

    const atPercCharge =
      ((wOCollection?.total_transaction_amount || 0) *
        (percFeeParent1 - percFeeParent2)) /
      100;
    const atFixedFee =
      (wOCollection?.total_transactions || 0) *
      (fixedFeeParent1 - fixedFeeParent2);
    const failureFeeAmout =
      (tsCollectionFailed?.total_count || 0) *
      (failureFeeParent1 - failureFeeParent2);
    const chargebackFees =
      (wOChargeback?.total_transactions || 0) *
      (chargebackFeeParent1 - chargebackFeeParent2);
    const refundFees =
      (wORefund?.total_transactions || 0) *
      (refundFeeParent1 - refundFeeParent2);

    const p1 = atPercCharge + atFixedFee + failureFeeAmout;
    const p2 = chargebackFees + refundFees;
    return (
      Number(p1 + p2) -
      (Number(otherDeductionsParent2) + Number(settlementFeeParent2))
    );
  };

  const getNetSettlementAmount = () => {
    const netAmount = getNetSuccessAmount() - totalDeductionAmount();
    return Number(netAmount) + Number(otherAdditions);
  };
  const getNetSettlementAmountParent1 = () => {
    if (!merchantIdParent1) return 0;
    const netAmount = totalDeductionAmountParent1();
    return Number(netAmount) + Number(otherAdditionsParent1);
  };
  const getNetSettlementAmountParent2 = () => {
    if (!merchantIdParent2) return 0;
    const netAmount = totalDeductionAmountParent2();
    return Number(netAmount) + Number(otherAdditionsParent2);
  };

  const getUsdAmount = () => {
    if (getNetSettlementAmount() <= 0) return 0;

    return Math.round(getNetSettlementAmount() * conversionRate * 100) / 100;
  };
  const getUsdAmountParent1 = () => {
    if (getNetSettlementAmountParent1() <= 0) return 0;
    return merchantIdParent1
      ? Math.round(
          getNetSettlementAmountParent1() * conversionRateParent1 * 100
        ) / 100
      : 0;
  };
  const getUsdAmountParent2 = () => {
    if (getNetSettlementAmountParent2() <= 0) return 0;
    return merchantIdParent2
      ? Math.round(
          getNetSettlementAmountParent2() * conversionRateParent2 * 100
        ) / 100
      : 0;
  };

  const getUsdAmountBank = () => {
    if (getNetSettlementAmount() <= 0) return 0;
    const resp = Math.round(
      getNetSettlementAmount() * conversionRateBank * 100
    );
    return resp / 100;
  };
  const getUsdAmountBankParent1 = () => {
    if (!merchantIdParent1) return 0;
    if (getNetSettlementAmountParent1() <= 0) return 0;

    const resp = Math.round(
      getNetSettlementAmountParent1() * conversionRateBank * 100
    );
    return resp / 100;
  };
  const getUsdAmountBankParent2 = () => {
    if (!merchantIdParent2) return 0;
    if (getNetSettlementAmountParent2() <= 0) return 0;

    const resp = Math.round(
      getNetSettlementAmountParent2() * conversionRateBank * 100
    );
    return resp / 100;
  };

  const getUsdtFee = () =>
    Math.round(((getUsdAmount() * usdtRate) / 100) * 100) / 100;
  const getUsdtFeeParent1 = () =>
    merchantIdParent1
      ? Math.round(((getUsdAmountParent1() * usdtRateParent1) / 100) * 100) /
        100
      : 0;
  const getUsdtFeeParent2 = () =>
    merchantIdParent2
      ? Math.round(((getUsdAmountParent2() * usdtRateParent2) / 100) * 100) /
        100
      : 0;

  const getUsdtFeeBank = () => {
    const resp = Math.round(((getUsdAmountBank() * usdtRateBank) / 100) * 100);
    return resp / 100;
  };
  const getUsdtFeeBankParent1 = () => {
    if (!merchantIdParent1) return 0;
    const resp = Math.round(
      ((getUsdAmountBankParent1() * usdtRateBank) / 100) * 100
    );
    return resp / 100;
  };
  const getUsdtFeeBankParent2 = () => {
    if (!merchantIdParent2) return 0;
    const resp = Math.round(
      ((getUsdAmountBankParent2() * usdtRateBank) / 100) * 100
    );
    return resp / 100;
  };

  const getUsdtAmount = () => getUsdAmount() - getUsdtFee();
  const getUsdtAmountParent1 = () =>
    merchantIdParent1 ? getUsdAmountParent1() - getUsdtFeeParent1() : 0;
  const getUsdtAmountParent2 = () =>
    merchantIdParent2 ? getUsdAmountParent2() - getUsdtFeeParent2() : 0;

  const getUsdtAmountBank = () => getUsdAmountBank() - getUsdtFeeBank();
  const getUsdtAmountBankParent1 = () =>
    merchantIdParent1 ? getUsdAmountBankParent1() - getUsdtFeeBankParent1() : 0;
  const getUsdtAmountBankParent2 = () =>
    merchantIdParent2 ? getUsdAmountBankParent2() - getUsdtFeeBankParent2() : 0;
  const fmt = (v) => new Intl.NumberFormat().format(v || 0);

  const overallUsdProfit = () => {
    const usdProfit = getUsdAmountBank() - getUsdAmount();
    let usdProfitParent1 = merchantIdParent1
      ? getUsdAmountBankParent1() - getUsdAmountParent1()
      : 0;
    let usdProfitParent2 = merchantIdParent2
      ? getUsdAmountBankParent2() - getUsdAmountParent2()
      : 0;

    // If we are not settling by USDT
    if (getUsdAmountParent1() === 0) usdProfitParent1 = 0;
    if (getUsdAmountParent2() === 0) usdProfitParent2 = 0;

    return usdProfit + usdProfitParent1 + usdProfitParent2;
  };
  const overallUsdtProfit = () => {
    const usdtProfit = getUsdtAmountBank() - getUsdtAmount();
    let usdtProfitParent1 = merchantIdParent1
      ? getUsdtAmountBankParent1() - getUsdtAmountParent1()
      : 0;
    let usdtProfitParent2 = merchantIdParent2
      ? getUsdtAmountBankParent2() - getUsdtAmountParent2()
      : 0;

    // If we are not settling by USDT
    if (getUsdtAmountParent1() === 0) usdtProfitParent1 = 0;
    if (getUsdtAmountParent2() === 0) usdtProfitParent2 = 0;

    return usdtProfit + usdtProfitParent1 + usdtProfitParent2;
  };

  const sendEmail = () => {
    if (editable) {
      dispatch(
        updateSettlementReport(editable._id, {
          send_email: true,
          send_email_initiated: true,
          merchant_id: editable.merchant_id,
        })
      );
    }
  };

  const sendEmailParent1 = () => {
    if (editable) {
      dispatch(
        updateSettlementReport(editable._id, {
          send_email_parent1: true,
          send_email_initiated_parent1: true,
          merchant_id: editable.merchant_id,
        })
      );
    }
  };

  const sendEmailParent2 = () => {
    if (editable) {
      dispatch(
        updateSettlementReport(editable._id, {
          send_email_parent2: true,
          send_email_initiated_parent2: true,
          merchant_id: editable.merchant_id,
        })
      );
    }
  };

  const getProcessingProfitLog = () => {
    const pspCharges = {
      collection: {
        // UBA
        mpgs_simbacode_uba: {
          percentage: 4.8,
          fixed: 0,
        },
        mpgs_payfex_uba: {
          percentage: 4.5,
          fixed: 0.1,
        },
        // Coop
        vcs_simbacode_coop: {
          percentage: 4.5,
          fixed: 0,
        },
        // Equity
        mpgs_odoomarket_equity: {
          percentage: 4.5,
          fixed: 0,
        },
        mpgs_simbacode_equity: {
          percentage: 4.5,
          fixed: 0,
        },
      },
      refund: {},
      chargeback: {
        mpgs_payfex_uba: {
          percentage: 0,
          fixed: 5,
        },
      },
    };

    let ourTotalProcessingProfit = 0;
    const collectionProfitBreakDown = {};
    const refundProfitBreakDown = {};
    const chargebackProfitBreakDown = {};
    const wOCollectionPerPSP = wOCollection?.perPSP || [];
    const wORefundPerPSP = wORefund?.perPSP || [];
    const wOChargebackPerPSP = wOChargeback?.perPSP || [];

    // Collection - profit
    if (wOCollectionPerPSP?.length > 0) {
      for (let index = 0; index < wOCollectionPerPSP.length; index++) {
        const e = wOCollectionPerPSP[index];
        let pspCollectionCharges = {};
        if (pspCharges?.collection.hasOwnProperty(e?._id)) {
          pspCollectionCharges = pspCharges?.collection[e._id] || {};
        }

        const percCharge =
          Number(percFeeParent2) || Number(percFeeParent1) || Number(percFee);
        const percProfit =
          (e.total_transaction_amount *
            (percCharge - pspCollectionCharges.percentage)) /
          100;

        const fixedCharge =
          Number(fixedFeeParent2) ||
          Number(fixedFeeParent1) ||
          Number(fixedFee);
        const fixedProfit =
          e.total_transactions *
          (fixedCharge - (pspCollectionCharges?.fixed || 0));
        collectionProfitBreakDown[e._id] = {
          percentage: {
            profit: percProfit,
            fee: percCharge,
            feeByPSP: pspCollectionCharges?.percentage || 0,
          },
          fixed: {
            profit: fixedProfit,
            fee: fixedCharge,
            feeByPSP: pspCollectionCharges?.fixed || 0,
          },
        };
        ourTotalProcessingProfit += Number(percProfit) + Number(fixedProfit);
      }
    }

    // Refund - profit
    if (wORefundPerPSP?.length > 0) {
      for (let index = 0; index < wORefundPerPSP.length; index++) {
        const e = wORefundPerPSP[index];
        let pspRefundCharges = {};
        if (pspCharges?.refund.hasOwnProperty(e?._id)) {
          pspRefundCharges = pspCharges?.refund[e._id] || {};
        }

        const fixedCharge =
          Number(refundFeeParent2) ||
          Number(refundFeeParent1) ||
          Number(refundFee);
        const fixedProfit =
          e.total_transactions * (fixedCharge - (pspRefundCharges?.fixed || 0));
        refundProfitBreakDown[e._id] = {
          fixed: {
            profit: fixedProfit,
            fee: fixedCharge,
            feeByPSP: pspRefundCharges?.fixed || 0,
          },
        };
        ourTotalProcessingProfit += Number(fixedProfit);
      }
    }

    // Chargeback - profit
    if (wOChargebackPerPSP?.length > 0) {
      for (let index = 0; index < wOChargebackPerPSP.length; index++) {
        const e = wOChargebackPerPSP[index];
        let pspChargebackCharges = {};
        if (pspCharges?.chargeback?.hasOwnProperty(e?._id)) {
          pspChargebackCharges = pspCharges?.chargeback[e._id] || {};
        }

        const fixedCharge =
          Number(chargebackFeeParent2) ||
          Number(chargebackFeeParent1) ||
          Number(chargebackFee);
        const fixedProfit =
          e.total_transactions *
          (fixedCharge - (pspChargebackCharges?.fixed || 0));
        chargebackProfitBreakDown[e._id] = {
          fixed: {
            profit: fixedProfit,
            fee: fixedCharge,
            feeByPSP: pspChargebackCharges?.fixed || 0,
          },
        };
        ourTotalProcessingProfit += Number(fixedProfit);
      }
    }

    const ourCollectionProfitFailure =
      tsCollectionFailed.total_count *
      (Number(failureFeeParent2) ||
        Number(failureFeeParent1) ||
        Number(failureFee));
    ourTotalProcessingProfit += Number(ourCollectionProfitFailure);

    return {
      profit: ourTotalProcessingProfit,
      pspCharges,
      collectionProfitBreakDown: {
        ...collectionProfitBreakDown,
        ourCollectionProfitFailure,
      },
      refundProfitBreakDown,
      chargebackProfitBreakDown,
    };
  };

  const saveReport = () => {
    const beginDate = moment(dateRange[0]).format("YYYY-MM-DD");
    const endDate = moment(dateRange[1]).format("YYYY-MM-DD");
    const processingProfitDetails = getProcessingProfitLog();

    let reportData = {
      merchant_emails: merchantEmails,
      merchant_emails_parent1: merchantEmailsParent1,
      merchant_emails_parent2: merchantEmailsParent2,
      statement_date: moment(dateRange[1]).format("YYYY-MM-DD"),
      settlement_date: moment(dateRange[1]).add(editable?.card_settlement_period || selectedMerchant?.card_settlement_period, "day").format("YYYY-MM-DD"),
      begin_date: beginDate,
      end_date: endDate,
      card_settlement_period: editable?.card_settlement_period || selectedMerchant?.card_settlement_period,
      next_begin_date: moment(dateRange[1]).add(1, "day").format("YYYY-MM-DD"),
      //next_end_date: moment(dateRange[1]).add(selectedMerchant?.card_settlement_period, "day").format("YYYY-MM-DD"),
      next_end_date: `${moment(dateRange[1]).add(editable?.card_settlement_period || selectedMerchant?.card_settlement_period, "day").format("YYYY-MM-DD")}T23:59:59.999Z`,
      next_statement_date: `${moment(dateRange[1]).add(((editable?.card_settlement_period + 1) || (selectedMerchant?.card_settlement_period + 1)), "day").format("YYYY-MM-DD")}T01:59:59.999Z`,
      next_statement_created: nextStatementCreated,
      date_range: `${beginDate}|${endDate}`,
      timezone_label: editable?.timezone_label || timezone?.label,
      status: selectedStatus,
      status_parent1: selectedStatusParent1,
      status_parent2: selectedStatusParent2,
      rrstatus: selectedRRStatus,
      merchant_id: merchantId,
      merchant_id_parent1: merchantIdParent1,
      merchant_id_parent2: merchantIdParent2,
      business_name_parent1: merchantNameParent1,
      business_name_parent2: merchantNameParent2,
      merchant_code: editable?.merchant_code || selectedMerchant?.merchant_id,
      business_name: merchantName,
      wallet_currency_code: editable?.wallet_currency_code || wallet.code,
      payment_method: editable?.payment_method || selectedPaymentMethod,
      is_affiliate: editable?.is_affiliate || isAffiliate,
      successful_amount: wOCollection?.total_transaction_amount || 0,
      successful_count: wOCollection?.total_transactions || 0,
      failed_amount: tsCollectionFailed?.total_transaction_amount || 0,
      failed_count: tsCollectionFailed?.total_count || 0,
      refunds_amount: wORefund?.total_transaction_amount || 0,
      refunds_count: wORefund?.total_transactions || 0,
      chargebacks_amount: wOChargeback?.total_transaction_amount || 0,
      chargebacks_count: wOChargeback?.total_transactions || 0,
      perc_charge: percFee,
      perc_charge_parent1: percFeeParent1,
      perc_charge_parent2: percFeeParent2,
      perc_charge_amount:
        (Number(wOCollection?.total_transaction_amount || 0) * percFee) / 100,
      perc_charge_amount_parent1: merchantIdParent1
        ? (Number(wOCollection?.total_transaction_amount || 0) *
            (percFee - percFeeParent1)) /
          100
        : 0,
      perc_charge_amount_parent2: merchantIdParent2
        ? (Number(wOCollection?.total_transaction_amount || 0) *
            (percFeeParent1 - percFeeParent2)) /
          100
        : 0,
      fixed_charge: fixedFee,
      fixed_charge_parent1: fixedFeeParent1,
      fixed_charge_parent2: fixedFeeParent2,
      fixed_charge_amount:
        Number(wOCollection?.total_transactions || 0) * fixedFee,
      fixed_charge_amount_parent1: merchantIdParent1
        ? Number(wOCollection?.total_transactions || 0) *
          (fixedFee - fixedFeeParent1)
        : 0,
      fixed_charge_amount_parent2: merchantIdParent2
        ? Number(wOCollection?.total_transactions || 0) *
          (fixedFeeParent1 - fixedFeeParent2)
        : 0,
      failure_fee: failureFee,
      failure_fee_parent1: failureFeeParent1,
      failure_fee_parent2: failureFeeParent2,
      failure_fee_amount: tsCollectionFailed?.total_count * failureFee,
      failure_fee_amount_parent1: merchantIdParent1
        ? tsCollectionFailed?.total_count * (failureFee - failureFeeParent1)
        : 0,
      failure_fee_amount_parent2: merchantIdParent2
        ? tsCollectionFailed?.total_count *
          (failureFeeParent1 - failureFeeParent2)
        : 0,
      rolling_reserve: rollingReserve,
      rolling_reserve_amount: getRollingReserveAmount(),
      chargeback_fee: chargebackFee,
      chargeback_fee_parent1: chargebackFeeParent1,
      chargeback_fee_parent2: chargebackFeeParent2,
      chargeback_fee_amount:
        Number(wOChargeback?.total_transactions || 0) * chargebackFee,
      chargeback_fee_amount_parent1: merchantIdParent1
        ? Number(wOChargeback?.total_transactions || 0) *
          (chargebackFee - chargebackFeeParent1)
        : 0,
      chargeback_fee_amount_parent2: merchantIdParent2
        ? Number(wOChargeback?.total_transactions || 0) *
          (chargebackFeeParent1 - chargebackFeeParent2)
        : 0,
      refund_fee: refundFee,
      refund_fee_parent1: refundFeeParent1,
      refund_fee_parent2: refundFeeParent2,
      refund_fee_amount: Number(wORefund?.total_transactions || 0) * refundFee,
      refund_fee_amount_parent1: merchantIdParent1
        ? Number(wORefund?.total_transactions || 0) *
          (refundFee - refundFeeParent1)
        : 0,
      refund_fee_amount_parent2: merchantIdParent2
        ? Number(wORefund?.total_transactions || 0) *
          (refundFeeParent1 - refundFeeParent2)
        : 0,
      settlement_fee: Number(settlementFee),
      settlement_fee_parent1: Number(settlementFeeParent1),
      settlement_fee_parent2: Number(settlementFeeParent2),
      other_deduction_amount: Number(otherDeductions),
      other_deduction_amount_parent1: Number(otherDeductionsParent1),
      other_deduction_amount_parent2: Number(otherDeductionsParent2),
      net_successful_amount: getNetSuccessAmount(),
      total_deduction_amount: totalDeductionAmount(),
      total_deduction_amount_parent1: totalDeductionAmountParent1(),
      total_deduction_amount_parent2: totalDeductionAmountParent2(),
      other_additional_amount: Number(otherAdditions),
      other_additional_amount_parent1: Number(otherAdditionsParent1),
      other_additional_amount_parent2: Number(otherAdditionsParent2),
      net_settlement_amount: getNetSettlementAmount(),
      net_settlement_amount_parent1: getNetSettlementAmountParent1(),
      net_settlement_amount_parent2: getNetSettlementAmountParent2(),
      usd_rate: Number(conversionRate),
      usd_rate_parent1: Number(conversionRateParent1),
      usd_rate_parent2: Number(conversionRateParent2),
      usd_rate_bank: Number(conversionRateBank),
      usd_amount: getUsdAmount(),
      usd_amount_parent1: getUsdAmountParent1(),
      usd_amount_parent2: getUsdAmountParent2(),
      usd_amount_bank: getUsdAmountBank(),
      usd_profit: getUsdAmountBank() - getUsdAmount(),
      usd_profit_parent1: getUsdAmountBankParent1() - getUsdAmountParent1(),
      usd_profit_parent2: getUsdAmountBankParent2() - getUsdAmountParent2(),
      usdt_fee: Number(usdtRate),
      usdt_fee_parent1: Number(usdtRateParent1),
      usdt_fee_parent2: Number(usdtRateParent2),
      usdt_fee_bank: Number(usdtRateBank),
      usdt_fee_amount: getUsdtFee(),
      usdt_fee_amount_parent1: getUsdtFeeParent1(),
      usdt_fee_amount_parent2: getUsdtFeeParent2(),
      usdt_fee_amount_bank: getUsdtFeeBank(),
      usdt_settlement_amount: getUsdtAmount(),
      usdt_settlement_amount_parent1: getUsdtAmountParent1(),
      usdt_settlement_amount_parent2: getUsdtAmountParent2(),
      usdt_settlement_amount_bank: getUsdtAmountBank(),
      usdt_settlement_amount_bank_parent1: getUsdtAmountBankParent1(),
      usdt_settlement_amount_bank_parent2: getUsdtAmountBankParent2(),
      usdt_profit: getUsdtAmountBank() - getUsdtAmount(),
      usdt_profit_parent1: getUsdtAmountBankParent1() - getUsdtAmountParent1(),
      usdt_profit_parent2: getUsdtAmountBankParent2() - getUsdtAmountParent2(),
      usdt_address: usdtAddress,
      usdt_address_parent1: usdtAddressParent1,
      usdt_address_parent2: usdtAddressParent2,
      usdt_hash: usdtHash,
      usdt_hash_parent1: usdtHashParent1,
      usdt_hash_parent2: usdtHashParent2,
      notes,
      notes_parent1: notesParent1,
      notes_parent2: notesParent2,
      author_name: authUser.full_name,
      author_id: authUser._id,
      author_email: authUser.email,
      overall_usd_profit: overallUsdProfit(),
      overall_usdt_profit: overallUsdtProfit(),
      collection_overview: wOCollection?.total_transaction_amount
        ? wOCollection
        : null,
      refund_overview: wORefund?.total_transaction_amount ? wORefund : null,
      chargeback_overview: wOChargeback?.total_transaction_amount
        ? wOChargeback
        : null,
      processing_profit: processingProfitDetails?.profit,
      processing_profit_details: processingProfitDetails,
    };

    if (editable) {
      dispatch(updateSettlementReport(editable._id, reportData));
    } else {
      // For USD reports, send the email to the merchants automatically
      if (
        reportData?.wallet_currency_code === "USD" &&
        reportData?.net_settlement_amount > 0
      ) {
        reportData = {
          ...reportData,
          send_email: true,
          send_email_initiated: true,
        };
      }

      if (reportData?.net_settlement_amount === 0) {
        reportData = { ...reportData, status: "COMPLETED" };
      }
      if (reportData?.net_settlement_amount_parent1 === 0) {
        reportData = { ...reportData, status_parent1: "COMPLETED" };
      }
      if (reportData?.net_settlement_amount_parent2 === 0) {
        reportData = { ...reportData, status_parent2: "COMPLETED" };
      }
      if (reportData?.rolling_reserve_amount === 0) {
        reportData = { ...reportData, rrstatus: "COMPLETED" };
      }
      dispatch(createSettlementReport(reportData));
    }
  };
  return (
    <>
      {!puppeteerPDF && (
        <div id="report-filters">
          <Row>
            <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24}>
              {!editable && (
                <Select
                  allowClear
                  showArrow
                  style={{ width: "100%" }}
                  placeholder="Method"
                  onChange={(e) => onPaymentMethodChanged(e)}
                  showSearch
                  optionFilterProp="children"
                  value={selectedPaymentMethod}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {paymentMethodOptions}
                </Select>
              )}

              {editable && (
                <div>
                  <Row>
                    <Col
                      style={{ backgroundColor: "#f1f8ff", margin: "2px 15px" }}
                    >
                      <div style={{ margin: "2px 10px" }}>
                        Settlement Status:{" "}
                      </div>
                      <div style={{ margin: "2px 10px" }}>
                        Rolling Reserve:{" "}
                      </div>
                      <div style={{ margin: "2px 10px" }}>
                        Next Report Created:{" "}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ margin: "2px 10px" }}>
                        <Popover
                          content={
                            <Select
                              allowClear
                              showArrow
                              style={{ width: "100%" }}
                              placeholder="Method"
                              onChange={(e) => onStatusChanged(e)}
                              showSearch
                              optionFilterProp="children"
                              value={selectedStatus}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {settlementStatuses}
                            </Select>
                          }
                          title="Settlement Status"
                          trigger="click"
                        >
                          {selectedStatus}
                        </Popover>
                      </div>
                      <div style={{ margin: "2px 10px" }}>
                        <Popover
                          content={
                            <Select
                              allowClear
                              showArrow
                              style={{ width: "100%" }}
                              placeholder="Method"
                              onChange={(e) => onRRStatusChanged(e)}
                              showSearch
                              optionFilterProp="children"
                              value={selectedRRStatus}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {settlementStatuses}
                            </Select>
                          }
                          title="Rolling Reserve Status"
                          trigger="click"
                        >
                          {selectedRRStatus}
                        </Popover>
                      </div>
                      <div style={{ margin: "2px 10px" }}>
                        <Popover
                          content={
                            <Radio.Group
                              onChange={onChangeNextStatementCreated}
                              value={nextStatementCreated}
                            >
                              <Radio value>Yes</Radio>
                              <Radio value={false}>No</Radio>
                            </Radio.Group>
                          }
                          title="Next report was generated?"
                          trigger="click"
                        >
                          {nextStatementCreated ? "True" : "False"}
                        </Popover>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Col>
            <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24}>
              {!editable && (
                <RangePicker
                  value={dateRangeValue}
                  onChange={(_, dateString) =>
                    onDateRangeChanged(_, dateString)
                  }
                  style={{ width: "100%" }}
                />
              )}

              {editable && <div className="gx-d-flex justify-content-center" />}
            </Col>
            {!editable && isAffiliate && (
              <>
                <Col xl={8} lg={8} md={8} sm={8} xs={24}>
                  <Button
                    style={{ width: "100%" }}
                    onClick={selectChildMerchant}
                  >
                    {selectedChildMerchant?.name || "Child Merchant"}
                  </Button>
                </Col>
                <Modal
                  title="Select Child Merchant"
                  open={visibleSelectChildMerchantModal}
                  okText="Ok"
                  onCancel={closeSelectChildMerchantModal}
                  onOk={OkSelectChildMerchantModal}
                >
                  <Merchants onSelect={OkSelectChildMerchantModal} />
                </Modal>
              </>
            )}

            <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24}>
              <ButtonGroup>
                {!editable && (
                  <Button
                    loading={loadingWO || loadingTS}
                    key="submit"
                    className="gx-w-100 load-report-btn"
                    type="dashed"
                    onClick={loadReport}
                  >
                    Load
                  </Button>
                )}
                {editable && (
                  <>
                    {/* <Button
                      className="gx-w-100"
                      type="success"
                      icon={<FileOutlined />}
                      title="Download PDF"
                      onClick={() => download('settlement-report')}
                    />
                    <Button
                      className="gx-w-100"
                      type="info"
                      title="Download Transactions"
                      href={`${unicornApi}settlement-files/${editable?.merchant_id || selectedMerchant?._id}/${editable._id}`}
                      icon={<DownloadOutlined />}
                    /> */}
                    <Popconfirm
                      title="Sure to send PDF via email?"
                      onConfirm={() => sendEmail()}
                    >
                      <Button
                        type="warning"
                        title="Send PDF to Email"
                        icon={<MailOutlined />}
                      />
                    </Popconfirm>
                  </>
                )}
                {(editable ||
                  (loadReportClicked && !loadingTS && !loadingWO)) && (
                  <Can I="update" a={SETTLEMENT_REPORTS}>
                    <Button
                      loading={
                        creatingSettlementReport || updatingSettlementReport
                      }
                      className="gx-w-100 report-save-btn"
                      type="primary"
                      icon={<SaveOutlined />}
                      title="Save Report"
                      onClick={() => saveReport()}
                    />
                  </Can>
                )}
              </ButtonGroup>
            </Col>
          </Row>
          <Divider style={{ margin: "10px 0" }} />
        </div>
      )}

      {(editable || (loadReportClicked && !loadingTS && !loadingWO)) && (
        <div id="settlement-report">
          <br />
          <div style={{ marginBottom: 15, textAlign: "center" }}>
            <img
              src={logo}
              alt="Kitegateway"
              style={{ width: "15%" }}
              title="Kitegateway"
            />
          </div>

          <Row>
            <Col style={{ textAlign: "right" }} span={12}>
              <div style={{ width: 130, padding: "2px 5px", float: "right" }}>
                <div>Statement Date:</div>
                <div>Begin Date:</div>
                <div>End Date:</div>
                {!puppeteerParent1PDF && !puppeteerParent2PDF && (
                  <div>Settlement Due:</div>
                )}
              </div>
            </Col>
            <Col span={12}>
              <div style={{ padding: "2px 0px", float: "left" }}>
                <div>
                  {moment(statementDate).format("DD-MMM-YY")}{" "}
                  {editable?.timezone_label || timezone?.label}
                </div>
                <div>
                  {moment(dateRange[0]).format("DD-MMM-YY")}{" "}
                  {editable?.timezone_label || timezone?.label}
                </div>
                <div>
                  {moment(dateRange[1]).format("DD-MMM-YY")}{" "}
                  {editable?.timezone_label || timezone?.label}
                </div>
                {!puppeteerParent1PDF && !puppeteerParent2PDF && (
                  <div>
                    {moment(settlementDate).format("DD-MMM-YY")}{" "}
                    {editable?.timezone_label || timezone?.label}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {!puppeteerParent1PDF && !puppeteerParent2PDF && (
            <>
              <br />
              <Row>
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>Merchant</div>
                        <div>Currency</div>
                        <div>Code</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 0px" }}>
                        <div>{merchantName}</div>
                        <div>
                          {editable?.wallet_currency_code || wallet?.code}
                        </div>
                        <div>
                          {editable?.merchant_code || selectedMerchant?._id}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>Method</div>
                        <div>Report ID</div>
                        <div>Merchant ID</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 0px" }}>
                        <div>{selectedPaymentMethod}</div>
                        <div>{editable?._id || "N\\A"}</div>
                        <div>
                          {editable?.merchant_id || selectedMerchant?._id}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div />
                    </Col>
                    <Col span={14}>
                      <div
                        style={{
                          backgroundColor: "#f1f8ff",
                          padding: "2px 5px",
                        }}
                      >
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Amount</div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Count</div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Deductions</div>
                      </Col>
                      <Col span={14}>
                        <div>
                          <Row>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Rate</div>
                            </Col>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Amount</div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>Successful</div>
                        <div>Failed</div>
                        <div>Refunds</div>
                        <div>Chargebacks</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOCollection?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOCollection?.total_transactions)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <span>
                                  {fmt(
                                    tsCollectionFailed?.total_transaction_amount
                                  )}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <span>
                                  {fmt(tsCollectionFailed?.total_count)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wORefund?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>{fmt(wORefund?.total_transactions)}</span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOChargeback?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOChargeback?.total_transactions)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>MDR</div>
                        <div>Success Fee</div>
                        <div>Failure Fee</div>
                        <div>Rolling Reserve</div>
                        <div>Chargeback fee</div>
                        <div>Refund fee</div>
                        <div>Other Deductions</div>
                        <div>Settlement Fee</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={percFee}
                                    onChange={onChangePercentageFee}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Percentage Fee"
                                trigger="click"
                              >
                                {percFee}%
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    (wOCollection?.total_transaction_amount *
                                      percFee) /
                                      100
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={fixedFee}
                                    onChange={onChangeFixedFee}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Fixed Fee"
                                trigger="click"
                              >
                                {fixedFee}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wOCollection?.total_transactions * fixedFee
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={failureFee}
                                    onChange={onChangeFailureFee}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Failure Fee"
                                trigger="click"
                              >
                                {failureFee}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <>
                                  {fmt(
                                    tsCollectionFailed?.total_count * failureFee
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={rollingReserve}
                                    onChange={onChangeRollingReserve}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Rolling Reserve"
                                trigger="click"
                              >
                                {rollingReserve}%
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <>{fmt(getRollingReserveAmount())}</>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={chargebackFee}
                                    onChange={onChangeChargebackFee}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Chargeback Fee"
                                trigger="click"
                              >
                                {chargebackFee}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wOChargeback?.total_transactions *
                                      chargebackFee
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={refundFee}
                                    onChange={onChangeRefundFee}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Refund Fee"
                                trigger="click"
                              >
                                {refundFee}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wORefund?.total_transactions * refundFee
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={otherDeductions}
                                    onChange={onChangeOtherDeductions}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Other Deductions"
                                trigger="click"
                              >
                                {fmt(otherDeductions)}
                              </Popover>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={settlementFee}
                                    onChange={onChangeSettlementFee}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Settlement Fee"
                                trigger="click"
                              >
                                {fmt(settlementFee)}
                              </Popover>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Net Successful Transactions</div>
                      </Col>
                      <Col span={14}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <span>{fmt(getNetSuccessAmount())}</span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Total Deductions</div>
                      </Col>
                      <Col span={14}>
                        <div style={{ textAlign: "right" }}>
                          <span>{fmt(totalDeductionAmount())}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <br />
              <br />
              <br />
              <Row>
                <Col style={{ textAlign: "right" }} span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    Other Additions
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#f1f8ff",
                      padding: "2px 5px",
                    }}
                  >
                    <Popover
                      content={
                        <Input
                          value={otherAdditions}
                          onChange={onChangeOtherAdditions}
                          placeholder="Enter a value"
                        />
                      }
                      title="Other Additions"
                      trigger="click"
                    >
                      {fmt(otherAdditions)}
                    </Popover>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col style={{ textAlign: "right" }} span={12}>
                  <div
                    style={{
                      color: "#f1f8ff",
                      backgroundColor: "#232838",
                      padding: "10px 5px",
                    }}
                  >
                    Net Settlement Amount{" "}
                    {editable?.wallet_currency_code || wallet.code}
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#c6e5fb",
                      padding: "10px 5px",
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    <div>
                      {loadingTS && <span>loading... </span>}
                      {!loadingTS && (
                        <span>{fmt(getNetSettlementAmount())}</span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={12} />
                <Col span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Settlement Details</div>
                      </Col>
                      <Col span={14}>
                        <div>
                          <Row>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Rate</div>
                            </Col>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Amount</div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={12} />
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>{wallet?.code} to USD Rate</div>
                        <div>USD to USDT Fee</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={conversionRate}
                                    onChange={onChangeConversionRate}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Conversion Rate"
                                trigger="click"
                              >
                                {conversionRate}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingWO && !loadingTS && (
                                <>{fmt(getUsdAmount())}</>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={usdtRate}
                                    onChange={onChangeUsdtRate}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="USDT Rate"
                                trigger="click"
                              >
                                {usdtRate}%
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingWO && !loadingTS && (
                                <>{fmt(getUsdtFee())}</>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col span={12}>
                  <Row>
                    <Col>
                      {editable && (
                        <div
                          style={{ padding: "5px 25px", fontFamily: "auto" }}
                        >
                          <b>Download Transactions Report:</b>
                          <br />
                          {`${unicornApi}settlement-files/${
                            editable?.merchant_id || selectedMerchant?._id
                          }/${editable?._id}`}
                        </div>
                      )}
                      {!puppeteerPDF && (
                        <div style={{ padding: "5px 25px" }}>
                          <Popover
                            content={
                              <Select
                                value={merchantEmails}
                                mode="tags"
                                style={{ width: "100%" }}
                                placeholder="Merchant reporting emails"
                                onChange={onChangeMerchantEmails}
                              />
                            }
                            title="Merchant Reporting Emails"
                            trigger="click"
                          >
                            <b>Reporting emails:</b>
                            <br />
                            {merchantEmails?.join(",") || "undefined"}
                          </Popover>
                        </div>
                      )}
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input
                              value={usdtAddress}
                              onChange={onChangeUsdtAddress}
                              placeholder="Enter a value"
                            />
                          }
                          title="USDT Address or Account Number"
                          trigger="click"
                        >
                          <b>USDT/ACC Address/No</b>
                          <br />
                          {usdtAddress}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input
                              value={usdtHash}
                              onChange={onChangeUsdtHash}
                              placeholder="Enter a value"
                            />
                          }
                          title="USDT Hash or SWIFT Reference"
                          trigger="click"
                        >
                          <b>TXN Hash/Ref</b>
                          <br />
                          {usdtHash}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input.TextArea
                              rows={2}
                              value={notes}
                              onChange={onChangeNotes}
                              placeholder="Enter a value"
                            />
                          }
                          title="Notes"
                          trigger="click"
                        >
                          <b>Notes</b>
                          <br />
                          {notes}
                        </Popover>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#c6e5fb",
                      padding: "10px 5px",
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    <Row>
                      <Col span={10}>USDT Settlement</Col>
                      <Col span={14}>
                        <Row>
                          <Col span={12} />
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingTS && !loadingWO && (
                                <span>{fmt(getUsdtAmount())}</span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      )}

      {/* // Bank FX Details */}
      {!puppeteerPDF &&
        (editable || (loadReportClicked && !loadingTS && !loadingWO)) && (
          <div id="report-bank-fx-fees">
            <Row>
              <Col span={12} />
              <Col span={12}>
                <div style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}>
                  <Row>
                    <Col span={10}>
                      <div>Bank/Supplier Rates</div>
                    </Col>
                    <Col span={14}>
                      <div>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Rate</div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Amount</div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={12} />
              <Col span={12}>
                <Row>
                  <Col span={10}>
                    <div
                      style={{
                        color: "#f1f8ff",
                        backgroundColor: "#444e6e",
                        padding: "2px 5px",
                      }}
                    >
                      <div>{wallet?.code} to USD Rate</div>
                      <div>USD to USDT Fee</div>
                    </div>
                  </Col>
                  <Col span={14}>
                    <div style={{ padding: "2px 5px" }}>
                      <Row>
                        <Col span={12}>
                          <div style={{ textAlign: "right" }}>
                            <Popover
                              content={
                                <Input
                                  value={conversionRateBank}
                                  onChange={onChangeConversionRateBank}
                                  placeholder="Enter a value"
                                />
                              }
                              title="Bank Conversion Rate"
                              trigger="click"
                            >
                              {conversionRateBank}
                            </Popover>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div style={{ textAlign: "right" }}>
                            {(loadingWO || loadingTS) && (
                              <span>loading... </span>
                            )}
                            {!loadingWO && !loadingTS && (
                              <>{fmt(getUsdAmountBank())}</>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={12}>
                          <div style={{ textAlign: "right" }}>
                            <Popover
                              content={
                                <Input
                                  value={usdtRateBank}
                                  onChange={onChangeUsdtRateBank}
                                  placeholder="Enter a value"
                                />
                              }
                              title="Bank USDT Rate"
                              trigger="click"
                            >
                              {usdtRateBank}%
                            </Popover>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div style={{ textAlign: "right" }}>
                            {(loadingWO || loadingTS) && (
                              <span>loading... </span>
                            )}
                            {!loadingWO && !loadingTS && (
                              <>{fmt(getUsdtFeeBank())}</>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col span={12} />
              <Col span={12}>
                <div
                  style={{
                    backgroundColor: "#c6e5fb",
                    padding: "10px 5px",
                    fontWeight: 500,
                    fontSize: 15,
                  }}
                >
                  <Row>
                    <Col span={10}>USDT Settlement from Bank</Col>
                    <Col span={14}>
                      <Row>
                        <Col span={12} />
                        <Col span={12}>
                          <div style={{ textAlign: "right" }}>
                            {(loadingWO || loadingTS) && (
                              <span>loading... </span>
                            )}
                            {!loadingTS && !loadingWO && (
                              <span>{fmt(getUsdtAmountBank())}</span>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        )}

      {(!puppeteerPDF || puppeteerParent1PDF) &&
        merchantIdParent1 &&
        (editable || loadReportClicked) && (
          <div id="report-parent1-section">
            <Divider />
            {/* // Parent 1 */}
            <br />
            <br />
            <div
              id="parent1-commissions"
              style={{ padding: 10, backgroundColor: "lightblue" }}
            >
              <div style={{ margin: "2px 10px" }}>
                <Button.Group>
                  {!puppeteerPDF && (
                    <div style={{ marginRight: 10 }}>
                      <Popconfirm
                        title="Sure to send PDF via email?"
                        onConfirm={() => sendEmailParent1()}
                      >
                        <Button
                          type="warning"
                          title="Send PDF to Email"
                          icon={<MailOutlined />}
                        />
                      </Popconfirm>
                    </div>
                  )}
                  <h2>
                    {merchantNameParent1 || "Parent1"} (Commissions) from{" "}
                    {merchantName || ""}
                  </h2>
                </Button.Group>
              </div>
              <Row>
                <Col span={8}>
                  <Row>
                    <Col span={10} />
                    <Col span={14}>
                      <div
                        style={{
                          backgroundColor: "#f1f8ff",
                          padding: "2px 5px",
                        }}
                      >
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Amount</div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Count</div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={16}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={8} />
                      <Col span={16}>
                        <div>
                          <Row>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                {merchantName || ""}
                              </div>
                            </Col>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                {merchantNameParent1 || "Parent1"}
                              </div>
                            </Col>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                Comm Rate
                              </div>
                            </Col>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                Comm Amount
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={8}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>Successful</div>
                        <div>Failed</div>
                        <div>Refunds</div>
                        <div>Chargebacks</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOCollection?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOCollection?.total_transactions)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <span>
                                  {fmt(
                                    tsCollectionFailed?.total_transaction_amount
                                  )}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <span>
                                  {fmt(tsCollectionFailed?.total_count)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wORefund?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>{fmt(wORefund?.total_transactions)}</span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOChargeback?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOChargeback?.total_transactions)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={16}>
                  <Row>
                    <Col span={8}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>MDR</div>
                        <div>Success Fee</div>
                        <div>Failure Fee</div>
                        <div>Chargeback fee</div>
                        <div>Refund fee</div>
                        <div>Any Deductions</div>
                        <div>Settlement Fee</div>
                      </div>
                    </Col>
                    <Col span={16}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>{percFee}%</div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={percFeeParent1}
                                    onChange={onChangePercentageFeeParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Percentage Fee"
                                trigger="click"
                              >
                                {percFeeParent1}%
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(percFee - percFeeParent1)}%
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    (wOCollection?.total_transaction_amount *
                                      (percFee - percFeeParent1)) /
                                      100
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>{fixedFee}</div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={fixedFeeParent1}
                                    onChange={onChangeFixedFeeParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Fixed Fee"
                                trigger="click"
                              >
                                {fixedFeeParent1}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(fixedFee - fixedFeeParent1)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wOCollection?.total_transactions *
                                      (fixedFee - fixedFeeParent1)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {failureFee}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={failureFeeParent1}
                                    onChange={onChangeFailureFeeParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Failure Fee"
                                trigger="click"
                              >
                                {failureFeeParent1}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(failureFee - failureFeeParent1)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <>
                                  {fmt(
                                    tsCollectionFailed?.total_count *
                                      (failureFee - failureFeeParent1)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {chargebackFee}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={chargebackFeeParent1}
                                    onChange={onChangeChargebackFeeParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Chargeback Fee"
                                trigger="click"
                              >
                                {chargebackFeeParent1}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(chargebackFee - chargebackFeeParent1)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wOChargeback?.total_transactions *
                                      (chargebackFee - chargebackFeeParent1)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {refundFee}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={refundFeeParent1}
                                    onChange={onChangeRefundFeeParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Refund Fee"
                                trigger="click"
                              >
                                {refundFeeParent1}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(refundFee - refundFeeParent1)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wORefund?.total_transactions *
                                      (refundFee - refundFeeParent1)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={otherDeductionsParent1}
                                    onChange={onChangeOtherDeductionsParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Other Deductions"
                                trigger="click"
                              >
                                {fmt(otherDeductionsParent1)}
                              </Popover>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={settlementFeeParent1}
                                    onChange={onChangeSettlementFeeParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Settlement Fee"
                                trigger="click"
                              >
                                {fmt(settlementFeeParent1)}
                              </Popover>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={8} />
                <Col span={16}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Total Commission</div>
                      </Col>
                      <Col span={14}>
                        <div style={{ textAlign: "right" }}>
                          <span>{fmt(totalDeductionAmountParent1())}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <br />
              <br />
              <br />
              <Row>
                <Col style={{ textAlign: "right" }} span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    Other Additions
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#f1f8ff",
                      padding: "2px 5px",
                    }}
                  >
                    <Popover
                      content={
                        <Input
                          value={otherAdditionsParent1}
                          onChange={onChangeOtherAdditionsParent1}
                          placeholder="Enter a value"
                        />
                      }
                      title="Other Additions"
                      trigger="click"
                    >
                      {fmt(otherAdditionsParent1)}
                    </Popover>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col style={{ textAlign: "right" }} span={12}>
                  <div
                    style={{
                      color: "#f1f8ff",
                      backgroundColor: "#232838",
                      padding: "10px 5px",
                    }}
                  >
                    Net Settlement Amount{" "}
                    {editable?.wallet_currency_code || wallet.code}
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#c6e5fb",
                      padding: "10px 5px",
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    <div>
                      {loadingTS && <span>loading... </span>}
                      {!loadingTS && (
                        <span>{fmt(getNetSettlementAmountParent1())}</span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={12} />
                <Col span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Settlement Details</div>
                      </Col>
                      <Col span={14}>
                        <div>
                          <Row>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Rate</div>
                            </Col>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Amount</div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={12} />
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>{wallet?.code} to USD Rate</div>
                        <div>USD to USDT Fee</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={conversionRateParent1}
                                    onChange={onChangeConversionRateParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Conversion Rate"
                                trigger="click"
                              >
                                {conversionRateParent1}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingWO && !loadingTS && (
                                <>{fmt(getUsdAmountParent1())}</>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={usdtRateParent1}
                                    onChange={onChangeUsdtRateParent1}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="USDT Rate"
                                trigger="click"
                              >
                                {usdtRateParent1}%
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingWO && !loadingTS && (
                                <>{fmt(getUsdtFeeParent1())}</>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col span={12}>
                  <Row>
                    <Col>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Select
                              allowClear
                              showArrow
                              style={{ width: "100%" }}
                              placeholder="Method"
                              onChange={(e) => onStatusChangedParent1(e)}
                              showSearch
                              optionFilterProp="children"
                              value={selectedStatusParent1}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {settlementStatuses}
                            </Select>
                          }
                          title="Settlement Status"
                          trigger="click"
                        >
                          Commission Settlement: {selectedStatusParent1}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input
                              value={usdtAddressParent1}
                              onChange={onChangeUsdtAddressParent1}
                              placeholder="Enter a value"
                            />
                          }
                          title="USDT Address or Account Number"
                          trigger="click"
                        >
                          <b>USDT/ACC Address/No</b>
                          <br />
                          {usdtAddressParent1}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input
                              value={usdtHashParent1}
                              onChange={onChangeUsdtHashParent1}
                              placeholder="Enter a value"
                            />
                          }
                          title="USDT Hash or SWIFT Reference"
                          trigger="click"
                        >
                          <b>TXN Hash/Ref</b>
                          <br />
                          {usdtHashParent1}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input.TextArea
                              rows={2}
                              value={notesParent1}
                              onChange={onChangeNotesParent1}
                              placeholder="Enter a value"
                            />
                          }
                          title="Notes"
                          trigger="click"
                        >
                          <b>Notes</b>
                          <br />
                          {notesParent1}
                        </Popover>
                      </div>
                      {!puppeteerPDF && (
                        <div style={{ padding: "5px 25px" }}>
                          <Popover
                            content={
                              <Select
                                value={merchantEmailsParent1}
                                mode="tags"
                                style={{ width: "100%" }}
                                placeholder="Parent reporting emails"
                                onChange={onChangeMerchantEmailsParent1}
                              />
                            }
                            title="Parent Reporting Emails"
                            trigger="click"
                          >
                            <b>Reporting emails:</b>
                            <br />
                            {merchantEmailsParent1?.join(",") || "undefined"}
                          </Popover>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#c6e5fb",
                      padding: "10px 5px",
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    <Row>
                      <Col span={10}>USDT Settlement</Col>
                      <Col span={14}>
                        <Row>
                          <Col span={12} />
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingTS && !loadingWO && (
                                <span>{fmt(getUsdtAmountParent1())}</span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}

      {(!puppeteerPDF || puppeteerParent2PDF) &&
        merchantIdParent2 &&
        (editable || loadReportClicked) && (
          <div id="report-parent2-section">
            {!puppeteerPDF && (
              <>
                <br />
                <br />
                <br />
                <br />
              </>
            )}
            {/* // Parent2 */}
            <Divider />
            {!puppeteerPDF && (
              <>
                <br />
                <br />
                <br />
                <br />
              </>
            )}
            <div
              id="parent2-commissions"
              style={{ padding: 10, backgroundColor: "lightblue" }}
            >
              <div>
                <Button.Group>
                  {!puppeteerPDF && (
                    <div style={{ marginRight: 10 }}>
                      <Popconfirm
                        title="Sure to send PDF via email?"
                        onConfirm={() => sendEmailParent2()}
                      >
                        <Button
                          type="warning"
                          title="Send PDF to Email"
                          icon={<MailOutlined />}
                        />
                      </Popconfirm>
                    </div>
                  )}{" "}
                  <h2>
                    {merchantNameParent2 || "Parent2"} (Commissions) from{" "}
                    {merchantNameParent1 || "Parent1"}
                  </h2>
                </Button.Group>
              </div>
              <Row>
                <Col span={8}>
                  <Row>
                    <Col span={10} />
                    <Col span={14}>
                      <div
                        style={{
                          backgroundColor: "#f1f8ff",
                          padding: "2px 5px",
                        }}
                      >
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Amount</div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>Count</div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={16}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={8} />
                      <Col span={16}>
                        <div>
                          <Row>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                {merchantNameParent1 || "Parent1"}
                              </div>
                            </Col>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                {merchantNameParent2 || "Parent2"}
                              </div>
                            </Col>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                Comm Rate
                              </div>
                            </Col>
                            <Col span={6}>
                              <div style={{ textAlign: "right" }}>
                                Comm Amount
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={8}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>Successful</div>
                        <div>Failed</div>
                        <div>Refunds</div>
                        <div>Chargebacks</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOCollection?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOCollection?.total_transactions)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <span>
                                  {fmt(
                                    tsCollectionFailed?.total_transaction_amount
                                  )}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <span>
                                  {fmt(tsCollectionFailed?.total_count)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wORefund?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>{fmt(wORefund?.total_transactions)}</span>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOChargeback?.total_transaction_amount)}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <span>
                                  {fmt(wOChargeback?.total_transactions)}
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={16}>
                  <Row>
                    <Col span={8}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>MDR</div>
                        <div>Success Fee</div>
                        <div>Failure Fee</div>
                        <div>Chargeback fee</div>
                        <div>Refund fee</div>
                        <div>Any Deductions</div>
                        <div>Settlement Fee</div>
                      </div>
                    </Col>
                    <Col span={16}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {percFeeParent1}%
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={percFeeParent2}
                                    onChange={onChangePercentageFeeParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Percentage Fee"
                                trigger="click"
                              >
                                {percFeeParent2}%
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(percFeeParent1 - percFeeParent2)}%
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    (wOCollection?.total_transaction_amount *
                                      (percFeeParent1 - percFeeParent2)) /
                                      100
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fixedFeeParent1}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={fixedFeeParent2}
                                    onChange={onChangeFixedFeeParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Fixed Fee"
                                trigger="click"
                              >
                                {fixedFeeParent2}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(fixedFeeParent1 - fixedFeeParent2)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wOCollection?.total_transactions *
                                      (fixedFeeParent1 - fixedFeeParent2)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {failureFeeParent1}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={failureFeeParent2}
                                    onChange={onChangeFailureFeeParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Failure Fee"
                                trigger="click"
                              >
                                {failureFeeParent2}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(failureFeeParent1 - failureFeeParent2)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingTS && <span>loading... </span>}
                              {!loadingTS && (
                                <>
                                  {fmt(
                                    tsCollectionFailed?.total_count *
                                      (failureFeeParent1 - failureFeeParent2)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {chargebackFeeParent1}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={chargebackFeeParent2}
                                    onChange={onChangeChargebackFeeParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Chargeback Fee"
                                trigger="click"
                              >
                                {chargebackFeeParent2}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(chargebackFeeParent1 - chargebackFeeParent2)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wOChargeback?.total_transactions *
                                      (chargebackFeeParent1 -
                                        chargebackFeeParent2)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {refundFeeParent1}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={refundFeeParent2}
                                    onChange={onChangeRefundFeeParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Refund Fee"
                                trigger="click"
                              >
                                {refundFeeParent2}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {fmt(refundFeeParent1 - refundFeeParent2)}
                            </div>
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              {loadingWO && <span>loading... </span>}
                              {!loadingWO && (
                                <>
                                  {fmt(
                                    wORefund?.total_transactions *
                                      (refundFeeParent1 - refundFeeParent2)
                                  )}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={otherDeductionsParent2}
                                    onChange={onChangeOtherDeductionsParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Other Deductions"
                                trigger="click"
                              >
                                {fmt(otherDeductionsParent2)}
                              </Popover>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }} />
                          </Col>
                          <Col span={6}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={settlementFeeParent2}
                                    onChange={onChangeSettlementFeeParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Settlement Fee"
                                trigger="click"
                              >
                                {fmt(settlementFeeParent2)}
                              </Popover>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={8} />
                <Col span={16}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Total Commission</div>
                      </Col>
                      <Col span={14}>
                        <div style={{ textAlign: "right" }}>
                          <span>{fmt(totalDeductionAmountParent2())}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <br />
              <br />
              <br />
              <Row>
                <Col style={{ textAlign: "right" }} span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    Other Additions
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#f1f8ff",
                      padding: "2px 5px",
                    }}
                  >
                    <Popover
                      content={
                        <Input
                          value={otherAdditionsParent2}
                          onChange={onChangeOtherAdditionsParent2}
                          placeholder="Enter a value"
                        />
                      }
                      title="Other Additions"
                      trigger="click"
                    >
                      {fmt(otherAdditionsParent2)}
                    </Popover>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col style={{ textAlign: "right" }} span={12}>
                  <div
                    style={{
                      color: "#f1f8ff",
                      backgroundColor: "#232838",
                      padding: "10px 5px",
                    }}
                  >
                    Net Settlement Amount{" "}
                    {editable?.wallet_currency_code || wallet.code}
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#c6e5fb",
                      padding: "10px 5px",
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    <div>
                      {loadingTS && <span>loading... </span>}
                      {!loadingTS && (
                        <span>{fmt(getNetSettlementAmountParent2())}</span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={12} />
                <Col span={12}>
                  <div
                    style={{ backgroundColor: "#f1f8ff", padding: "2px 5px" }}
                  >
                    <Row>
                      <Col span={10}>
                        <div>Settlement Details</div>
                      </Col>
                      <Col span={14}>
                        <div>
                          <Row>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Rate</div>
                            </Col>
                            <Col span={12}>
                              <div style={{ textAlign: "right" }}>Amount</div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={12} />
                <Col span={12}>
                  <Row>
                    <Col span={10}>
                      <div
                        style={{
                          color: "#f1f8ff",
                          backgroundColor: "#444e6e",
                          padding: "2px 5px",
                        }}
                      >
                        <div>{wallet?.code} to USD Rate</div>
                        <div>USD to USDT Fee</div>
                      </div>
                    </Col>
                    <Col span={14}>
                      <div style={{ padding: "2px 5px" }}>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={conversionRateParent2}
                                    onChange={onChangeConversionRateParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="Conversion Rate"
                                trigger="click"
                              >
                                {conversionRateParent2}
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingWO && !loadingTS && (
                                <>{fmt(getUsdAmountParent2())}</>
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              <Popover
                                content={
                                  <Input
                                    value={usdtRateParent2}
                                    onChange={onChangeUsdtRateParent2}
                                    placeholder="Enter a value"
                                  />
                                }
                                title="USDT Rate"
                                trigger="click"
                              >
                                {usdtRateParent2}%
                              </Popover>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingWO && !loadingTS && (
                                <>{fmt(getUsdtFeeParent2())}</>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col span={12}>
                  <Row>
                    <Col>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Select
                              allowClear
                              showArrow
                              style={{ width: "100%" }}
                              placeholder="Method"
                              onChange={(e) => onStatusChangedParent2(e)}
                              showSearch
                              optionFilterProp="children"
                              value={selectedStatusParent2}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {settlementStatuses}
                            </Select>
                          }
                          title="Settlement Status"
                          trigger="click"
                        >
                          Commission Settlement: {selectedStatusParent2}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input
                              value={usdtAddressParent2}
                              onChange={onChangeUsdtAddressParent2}
                              placeholder="Enter a value"
                            />
                          }
                          title="USDT Address or Account Number"
                          trigger="click"
                        >
                          <b>USDT/ACC Address/No</b>
                          <br />
                          {usdtAddressParent2}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input
                              value={usdtHashParent2}
                              onChange={onChangeUsdtHashParent2}
                              placeholder="Enter a value"
                            />
                          }
                          title="USDT Hash or SWIFT Reference"
                          trigger="click"
                        >
                          <b>TXN Hash/Ref</b>
                          <br />
                          {usdtHashParent2}
                        </Popover>
                      </div>
                      <div style={{ padding: "5px 25px" }}>
                        <Popover
                          content={
                            <Input.TextArea
                              rows={2}
                              value={notesParent2}
                              onChange={onChangeNotesParent2}
                              placeholder="Enter a value"
                            />
                          }
                          title="Notes"
                          trigger="click"
                        >
                          <b>Notes</b>
                          <br />
                          {notesParent2}
                        </Popover>
                      </div>
                      {!puppeteerPDF && (
                        <div style={{ padding: "5px 25px" }}>
                          <Popover
                            content={
                              <Select
                                value={merchantEmailsParent2}
                                mode="tags"
                                style={{ width: "100%" }}
                                placeholder="Parent reporting emails"
                                onChange={onChangeMerchantEmailsParent2}
                              />
                            }
                            title="Parent Reporting Emails"
                            trigger="click"
                          >
                            <b>Reporting emails:</b>
                            <br />
                            {merchantEmailsParent2?.join(",") || "undefined"}
                          </Popover>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <div
                    style={{
                      backgroundColor: "#c6e5fb",
                      padding: "10px 5px",
                      fontWeight: 500,
                      fontSize: 15,
                    }}
                  >
                    <Row>
                      <Col span={10}>USDT Settlement</Col>
                      <Col span={14}>
                        <Row>
                          <Col span={12} />
                          <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                              {(loadingWO || loadingTS) && (
                                <span>loading... </span>
                              )}
                              {!loadingTS && !loadingWO && (
                                <span>{fmt(getUsdtAmountParent2())}</span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      {autoSaveExecuted && <div id="autoSaveExecuted" />}

      {datesUpdated && <div id="datesUpdated" />}
    </>
  );
};

SettlementReport.propTypes = {
  wallet: PropTypes.oneOfType([PropTypes.any]),
  selectedMerchant: PropTypes.oneOfType([PropTypes.any]),
  editable: PropTypes.oneOfType([PropTypes.any]),
  isAffiliate: PropTypes.bool,
  puppeteerPDF: PropTypes.bool,
  puppeteerParent1PDF: PropTypes.bool,
  puppeteerParent2PDF: PropTypes.bool,
};

SettlementReport.defaultProps = {
  wallet: null,
  selectedMerchant: null,
  isAffiliate: false,
  editable: null,
  puppeteerPDF: false,
  puppeteerParent1PDF: false,
  puppeteerParent2PDF: false,
};

export default SettlementReport;
